import React from 'react';
import { Tooltip } from './Tooltip';
import { TextWithGlossaryProps } from '../types';
import { useGlossaryStore } from '../stores/glossary.store';

export const TextWithGlossary: React.FC<TextWithGlossaryProps> = ({ children, excludeGlossary = false }) => {
  const { terms, loading } = useGlossaryStore();

    const applyGlossary = (text: string): React.ReactNode[] => {
		const matches: {
			start: number;
			end: number;
			term: string;
			definition: string;
		}[] = [];

		terms.forEach(({ term, definition }) => {
			const regex = new RegExp(`\\b${term}\\b`, "gi");
			let match;
			while ((match = regex.exec(text)) !== null) {
				matches.push({
					start: match.index,
					end: match.index + match[0].length,
					term: match[0],
					definition,
				});
			}
		});

		matches.sort((a, b) => a.start - b.start);

		const elements: React.ReactNode[] = [];
		let lastIndex = 0;

		matches.forEach(({ start, end, term, definition }) => {
			if (start >= lastIndex) {
				if (start > lastIndex) {
					elements.push(text.slice(lastIndex, start));
				}

				elements.push(
					<Tooltip
						key={`${term}-${start}`}
						content={<span dangerouslySetInnerHTML={{ __html: definition }} />}
					>
						{term}
					</Tooltip>
				);

				lastIndex = end;
			}
		});

		if (lastIndex < text.length) {
			elements.push(text.slice(lastIndex));
		}

		return elements.length > 0 ? elements : [text];
	};

  const processNode = (node: React.ReactNode): React.ReactNode => {
    if (typeof node === 'string') {
      return applyGlossary(node);
    }

    if (React.isValidElement(node)) {
      const children = node.props.children;
      const processedChildren = React.Children.map(children, processNode);
      return React.cloneElement(node, {}, processedChildren);
    }

    return node;
  };

  if (excludeGlossary || loading || terms.length === 0) {
    return <>{children}</>;
  }

  const processed = React.Children.map(children, processNode);

  return <>{processed}</>;
};
